import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  nextPageLabel: {
    id: 'pagination_next_page_a11y_label',
  },

  prevPageLabel: {
    id: 'pagination_prev_page_a11y_label',
  },
});
